import axios from 'axios'
import url from './base-url';
const api = axios.create({
    baseURL: url
});
const timeout = 1000 * 5;
function Headers(auth) {
    return {headers:{ 'x-access-token': auth,'Content-Type': 'application/json'}};
}
export const insertManualOrder = (payload,auth) => api.post(`/order/manual-orders`, payload,Headers(auth));
export const getOrderById  = (id,auth) => api.get(`/order/${id}`,Headers(auth));
export const getAllOrders = (userId,storeName,status,auth) => api.get(`/orders/${storeName}/${status}/${userId}`,Headers(auth));
export const updateOrderById = (id, payload,auth) => api.put(`/order/${id}`, payload, Headers(auth));
export const deleteManualOrderById = (id,auth) => api.delete(`/order/${id}`,Headers(auth));
export const getEtsyOrders = (shopname,auth) => api.get(`/orders/etsy/${shopname}`,Headers(auth));
export const generateMultiplePackingSlips = (userId,payload,auth) => api.post(`/orders/generateMultiplePackingSlips/${userId}`, payload,Headers(auth));
export const generatePdf = (payload,auth) => api.post(`/orders/generatePackingSlips`, payload,Headers(auth));
export const generatePackingSlips = (userId,payload,auth) => api.post(`/order/generatePackingSlips/${userId}`, payload, {timeout:timeout},Headers(auth));
export const fetchPackingSlips = (orderIds) => api.get(`/orders/fetchPackingSlips/${orderIds}`,{ responseType: 'blob' });
export const downloadTemplate = (auth) => api.get(`/download/orderTemplate`, { responseType: 'blob' },Headers(auth));
export const importOrderProduct = (userId,payload,auth) => api.post(`/import/orderProduct/${userId}`, payload,Headers(auth));
export const getOrderNo = (userId,auth) =>api.get(`/order/manual-orders/OrderNo/${userId}`,Headers(auth));
const apis = {
    insertManualOrder,
    getOrderById,
    getAllOrders,
    updateOrderById,
    deleteManualOrderById,
    getEtsyOrders,
    generateMultiplePackingSlips,
    generatePackingSlips,
    generatePdf,
    fetchPackingSlips,
    downloadTemplate,
    importOrderProduct,
    getOrderNo
}

export default apis